






import {Component, Vue} from 'vue-property-decorator';
import {NotificationStore} from "@/services/implementations/NotificationStore";

@Component
export default class ErrorNotification extends Vue {
  status : NotificationStore = NotificationStore.getInstance();

  hideErrorMessage() {
    this.status.status = false;
    this.status.message = '';
  }
}
